import { Box, Container, Heading, Text, SimpleGrid, Icon, VStack, Center, Circle } from '@chakra-ui/react';
import { Smartphone, Sparkles, Download, CameraIcon } from 'lucide-react';
import React, { JSX } from 'react';
import ScrollReveal from 'components/ScrollReveal';

interface PropsInterface {
	children?: React.ReactNode;
}

function MobileAppUspSection(props: PropsInterface): JSX.Element {
	const features = [
		{ icon: CameraIcon, title: 'Photos', desc: 'Take photos and use them instantly for your images or videos.' },
		{ icon: Smartphone, title: 'Native Experience', desc: 'Smooth, fast performance on both iOS and Android.' },
		{
			icon: Download,
			title: 'One-Tap Export',
			desc: 'Send your creations directly to your device or social platforms.',
		},
		{ icon: Sparkles, title: 'AI Generation', desc: 'Generate stunning content in seconds using our mobile app.' },
	];

	return (
		<Box as="section" py="20" bg="realWhite" position={'relative'}>
			<Box position="absolute" inset="0" overflow="hidden" pointerEvents="none">
				<Circle
					position="absolute"
					top="16"
					left="25%"
					size="300px" // 80% of 96
					bg="blue.500/20"
					filter="blur(80px)"
				/>
				<Circle position="absolute" bottom="16" right="25%" size="300px" bg="teal.500/20" filter="blur(80px)" />
			</Box>
			<Container maxW="6xl">
				<VStack gap="3" mb="12" textAlign="center">
					<ScrollReveal>
						<Heading
							fontSize={{
								base: '3xl',
								sm: '4xl',
								lg: '4xl',
							}}
							lineHeight={1.25}
							color="gray.900"
							fontWeight={400}
						>
							Everything You Love,
							<br />
							<Text as="span" color={'gray.500'}>
								Now on Mobile
							</Text>
						</Heading>
					</ScrollReveal>
					<ScrollReveal delay={0.2}>
						<Text fontSize="md" color="gray.600" maxW="xl" textAlign={'center'} margin={'0 auto'}>
							All the powerful features of Imagemotion, optimized for your smartphone.
						</Text>
					</ScrollReveal>
				</VStack>

				<SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap="6">
					{features.map((feature, i) => (
						<ScrollReveal key={i} delay={0.1 * i} direction="up">
							<Box
								p="6"
								shadow={'md'}
								rounded="2xl"
								border="1px solid"
								borderColor="gray.100"
								transition="all 0.3s"
								_hover={{ transform: 'translateY(-2px)', shadow: 'md', bg: 'realWhite/50' }}
								h="full"
							>
								<Center
									boxSize="12"
									bgGradient="to-br"
									gradientFrom="primary"
									gradientTo="secondary"
									rounded="xl"
									mb="4"
								>
									<Icon as={feature.icon} size="md" color="white" />
								</Center>
								<Heading size="sm" mb="2" color="gray.900">
									{feature.title}
								</Heading>
								<Text fontSize="sm" color="gray.600">
									{feature.desc}
								</Text>
							</Box>
						</ScrollReveal>
					))}
				</SimpleGrid>
			</Container>
		</Box>
	);
}
export default MobileAppUspSection;
